import { createFileRoute } from '@tanstack/react-router';

import { ProductionPlannerTimelineView } from '../../features/production-planner/production-planner-timeline-view';

export const Route = createFileRoute('/production-planner/timeline')({
  staticData: {
    section: 'Planner',
    breadcrumb: 'Production Planner — Timeline',
    layout: 'full-height',
  },
  component: ProductionPlannerTimelineView,
});
